import { render, staticRenderFns } from "./_EditTransportLocationDialog.vue?vue&type=template&id=c0f16516&scoped=true&"
import script from "./_EditTransportLocationDialog.vue?vue&type=script&lang=js&"
export * from "./_EditTransportLocationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f16516",
  null
  
)

export default component.exports